import gsap from '../../js/gsap/gsap.min.js';
import SplitText from '../../js/gsap/SplitText.min.js';
import { ScrollTrigger } from '../../js/gsap/ScrollTrigger.min.js';
import "../../js/theme/_lenis.js";
// import "../../js/theme/_slider.js";


if (document.querySelector("section") != null) {
  const coptions = {
    root: null
    }; 
  
    let revealCallback = (entries) => {
      entries.forEach((entry) => {
        let container = entry.target;
        if (entry.isIntersecting) {
          // Check for the specific classes and add corresponding animation classes
          if (container.classList.contains("animatedFadeInUp")) {
            container.classList.add("fadeInUp");
          } else if (container.classList.contains("animatedFadeDown")) {
            container.classList.add("fadeInDown");
          }
        } 
      });  
    };
  
    let revealObserver = new IntersectionObserver(revealCallback, coptions);
  
    document.querySelectorAll(".animated").forEach((reveal) => {
      revealObserver.observe(reveal); 
    });
  }

const header = document.getElementById("wrapper-navbar");
    header.classList.add("sticky");

function addClass() {
  header.classList.add('scrolling');
}
function removeClass() {
  header.classList.remove('scrolling')
}
ScrollTrigger.addEventListener('scrollStart', addClass)
ScrollTrigger.addEventListener('scrollEnd', removeClass)

let mm = gsap.matchMedia();

mm.add("(min-width: 992px)", () => {
if (document.querySelectorAll(".home-move") != null) {

  const homeMoves = document.querySelectorAll(".home-move");
 
  if (homeMoves.length > 0) {
   homeMoves.forEach(homeMove => {
 
     // Animation for the content
     gsap.to(".home-move-content", {
       y: 150,
       ease: "none",
       scrollTrigger: {
         trigger: homeMove, // Each individual '.home-move' element
         scrub: true,
       },
     });
   });
 }
 }


 if (document.querySelector(".para-callout") != null) {
  gsap.to(".pContent", {
    yPercent: -200,
    ease: "none",
    scrollTrigger: {
      trigger: ".para-callout",
      // start: "top bottom", // the default values
      // end: "bottom top",
      scrub: true
    }, 
  });
  
  gsap.to(".pImagex", {
    yPercent: 20, 
    ease: "none",
    scrollTrigger: {
      trigger: ".para-callout",
      // start: "top bottom", // the default values
      // end: "bottom top",
      scrub: true
    }, 
  });
  }


  if (document.querySelector(".sub_img-holder") != null) {
    gsap.utils.toArray(".sub_img-holder").forEach(function(container) {
      let image = container.querySelector("img");
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          scrub: true,
          pin: false,
        }
      });
    
      tl.fromTo(image, {
        yPercent: -20,
        ease: 'none'
      }, {
        yPercent: 20,
        ease: 'none'
      });
    });
    
    }

});

mm.add("(min-width: 1200px)", () => {
  const showAnim = gsap.from(header, { 
    yPercent: -100,
    paused: true,
    duration: 0.8,
    delay: 1,
  }).progress(1);
  
  ScrollTrigger.create({
    start: '400px',
    
    end: () => ScrollTrigger.maxScroll(window) + 10,
    onUpdate: (self) => {
      self.direction === -1 ? showAnim.play() : showAnim.reverse()
    },
    onLeave: () => showAnim.play()
  });
  
const mainMenu = document.getElementById('main-menu');
const menuBg = document.querySelector('.menu-bg');
const bigMenu = document.querySelector('.big-menu');
// const svg = bigMenu.querySelector('svg'); 

function addHighlight() {
    menuBg.classList.add('is-open');
    bigMenu.classList.add('is-open');
}

function removeHighlight() {
    menuBg.classList.remove('is-open');
    bigMenu.classList.remove('is-open');
   
    jQuery('.menu-content').removeClass('is-open'); // Remove is-open class when highlight is removed
    // svg.style.transform = 'translateX(-100%)'; 
}

// Add highlight when entering main menu
mainMenu.addEventListener('mouseenter', addHighlight);

// Keep highlight when moving to big menu
bigMenu.addEventListener('mouseenter', addHighlight);

// Remove highlight when leaving big menu or main menu
bigMenu.addEventListener('mouseleave', removeHighlight);
mainMenu.addEventListener('mouseleave', (event) => {
    if (!bigMenu.contains(event.relatedTarget)) {
        removeHighlight();
    }
});
bigMenu.addEventListener('transitionend', function() {

});

}); 



if (document.querySelector(".data") != null) {
const items = document.querySelectorAll(".data");
const observer = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      // If the item is in the viewport, apply the GSAP animation
      gsap.from(entry.target, {
        textContent: 0,
        duration: 2,
        ease: Power1.easeIn,
        snap: { textContent: 1 },
        stagger: {
          onUpdate: function() {
            this.targets()[0].innerHTML = numberWithCommas(Math.ceil(this.targets()[0].textContent));
          },
        }
      });
      // Stop observing the element after the animation starts
      observer.unobserve(entry.target);
    }
  });
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}, {
  threshold: 0.5  // Trigger when at least 50% of the element is in view
});

// Observe each item
items.forEach(item => {
  observer.observe(item);
});

}


if (document.querySelector(".text-quote") != null) {
const textQuoteElement = document.querySelector(".text-quote");
// Ensure text-quote is visible (autoAlpha = 1) by default
gsap.set(textQuoteElement, { autoAlpha: 0 });

// Create the Intersection Observer
const quoteObserver = new IntersectionObserver((entries, quoteObserver) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            // GSAP animation code when the element is in view
            var tl = gsap.timeline(),
                mySplitText = new SplitText(".text-quote", { type: "words,chars" }),
                chars = mySplitText.chars;

                tl.to(textQuoteElement, {
                  duration: 0.2,
                  autoAlpha: 1,  // autoAlpha animates both opacity and visibility
                  ease: "back",   // Easing for smooth transition
              });
            // Add the character animation (staggered fade-in, scale, and move up)
            tl.from(chars, {
                duration: 0.2,
                opacity: 0,
                ease: "back",
                stagger: 0.01
            });

            // Stop observing once the animation is triggered
            quoteObserver.unobserve(entry.target);
        }
    });
}, {
    threshold: 0.25 // Trigger when 25% of the element is in view
});

// Observe the element
if (textQuoteElement) {
    quoteObserver.observe(textQuoteElement);
}
}





if (document.querySelector("#vimeo-video") != null) {

  // Check if .video-cover exists before adding the 'playing' class
  if (jQuery('.video-cover').length) {
    window.setTimeout(function() {
      var video = jQuery('.video-cover');
      video.addClass('playing');
    }, 2500);
  }

  // Check if the iframe with the ID #vimeo-video exists before proceeding
  var iframe = document.querySelector('#vimeo-video');
  if (iframe) {
    var player = new Vimeo.Player(iframe);

    // Create an IntersectionObserver to track visibility of the iframe
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          // Video is in the viewport, play it
          player.play().catch(function(error) {
            console.log('Error playing the video:', error);
          });
        } else {
          // Video is out of the viewport, pause it
          player.pause().catch(function(error) {
            console.log('Error pausing the video:', error);
          });
        }
      });
    }, {
      threshold: 0.5 // Trigger when 50% of the iframe is in view
    });

    // Start observing the video block
    observer.observe(iframe);
  }
}

    

    jQuery(document).ready(function () {

      jQuery('.willing-team-list').each(function (index, element) {
      jQuery(this).click(function () {
        var id = jQuery(this).attr('data-id');
        console.log(id);
        
        // Corrected selector and concatenation
        jQuery('.team-modal').removeClass('show');
        jQuery('.team-modal[data-id="' + id + '"]').addClass('show');
      });
    });
    
    var $page = jQuery('#page-wrapper');
    jQuery('#exampleModal').on('shown.bs.modal', function() {
        $page.addClass('modal-open');  // Add your custom class
      });
    
      // When the modal is hidden, remove the class from .page
      jQuery('#exampleModal').on('hidden.bs.modal', function() {
        $page.removeClass('modal-open');  // Remove your custom class
      });
    
    
    });
    
    jQuery('ul#main-menu li a').each(function (index, element) {
      var name = jQuery(this).attr('data-target');
      jQuery(this).hover(
          function() {
              console.log(name); // Logs the name when hovered
              
              // Hide all menu contents first
              jQuery('.menu-content').removeClass('is-open');
    
              // Show the current menu content
              jQuery("#" + name).addClass('is-open'); // Corrected selector
             
          },
          function() {
            
          }
      ); 
    });
     
    var bttbtn = jQuery('#bttbtn');
    var navbar = jQuery('#wrapper-navbar');
    
    function isLenisScrolling() {
        return jQuery('html').hasClass('lenis-scrolling');
    }
    
    jQuery(window).on("scroll", function() {
        var scrollTop = jQuery(window).scrollTop(); // Get the current scroll position
    
        // Toggle 'active' class on navbar based on scroll position
        if (scrollTop > 50) {
            navbar.addClass("active");
        } else {
            navbar.removeClass("active");
        }
    
        // Show or hide the "scroll to top" button based on scroll position
        if (scrollTop > 300) {
            bttbtn.addClass('show');
        } else {
            bttbtn.removeClass('show');
        }
    });
    
    // Scroll to top when the button is clicked
    bttbtn.on('click', function(e) {
        e.preventDefault();
    
        // Check if Lenis is currently scrolling
        if (!isLenisScrolling()) {
            console.log('Clicked - Lenis has finished scrolling');
            jQuery('html, body').animate({scrollTop: 0}, 300); // Scroll to the top with smooth animation
        } else {
            console.log('Button click ignored - Lenis is still scrolling');
        }
    });
    
    if (document.querySelector("#excavator") != null) {
    gsap.to(".excavator-body", 0.1, {y:"+=1", yoyo:true, repeat:-1});
gsap.to(".excavator-body", 0.1, {y:"-=1", yoyo:true, repeat:-1});
gsap.to(".excavator-road", 0, {x:145});
gsap.to(".excavator-road", 3, {x:-145, repeat:-1});
gsap.to(".excavator-hook", 0, {rotation:-10, transformOrigin:"50% 0%"});
gsap.to(".excavator-hook", 1, {rotation:10, transformOrigin:"50% 0%", repeat:-1, yoyo:true, ease: Sine.easeInOut});
    }

    if (document.querySelector("#honorWrap") != null) {
  
      const tabs = document.querySelectorAll('#honorWrap .nav-link');
      const tabContents = document.querySelectorAll('#honorWrap .tab-pane');
      let currentIndex = 0;
      let intervalId; // Variable to hold the interval ID
    
      function activateTab(index) {
        if (index >= tabs.length || index < 0) {
          console.error('Index out of bounds:', index);
          return;
        }
    
        // Remove 'active' class from all tabs and tab content panels
        tabs.forEach(tab => tab.classList.remove('active'));
        tabContents.forEach(content => {
          content.classList.remove('show', 'active');
          // Ensure the achievement-wrapper is reset before activating the new tab
         
        });
    
        // Check if the index corresponds to valid tab and content
        if (tabs[index] && tabContents[index]) {
          tabs[index].classList.add('active');
          tabContents[index].classList.add('show', 'active');
        } else {
          console.error('Invalid tab or tab content at index:', index);
        }
      }
    
      // Function to start the interval
      function startInterval() {
        clearInterval(intervalId); // Clear any existing interval
        intervalId = setInterval(() => {
          currentIndex = (currentIndex + 1) % tabs.length; // Loop back to the first tab when reaching the end
          activateTab(currentIndex);
        }, 8000); // 4 seconds interval
      }
    
      // Activate the first tab initially and start the interval
      activateTab(currentIndex);
      startInterval();
    
      // Add click event listener to each nav-link to restart the loop from that index
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          currentIndex = index; // Set the current index to the clicked tab's index
          activateTab(currentIndex); // Activate the clicked tab
          startInterval(); // Restart the interval from the clicked tab's index
        });
      });
    }
